import script from "./HomeWageHolidayPremiumDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeWageHolidayPremiumDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./HomeWageHolidayPremiumDetailModal.vue?vue&type=style&index=0&id=7880bc4e&lang=scss"

const __exports__ = script;

export default __exports__